import { Box, useColorModeValue } from "@chakra-ui/react";

interface PricingWrapperProps {
    children: any
}

const PricingWrapper: React.FC<PricingWrapperProps> = ({ children }) => {
    return (
        <Box
            mb={4}
            shadow="base"
            borderWidth="1px"
            alignSelf={{ base: 'center', lg: 'flex-start' }}
            borderColor={useColorModeValue('teal.200', 'teal.500')}
            borderRadius={'xl'}>
            {children}
        </Box>
    );
}

export default PricingWrapper;